var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElips1C7F3C9Ef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 97,
    viewBox: "0 0 105 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6618 122.831C20.4575 107.383 -4.94604 109.959 1.43557 91.3349C7.84603 72.6265 42.6127 59.7656 58.3672 47.8118C75.7903 34.5918 78.8748 2.44319 100.698 0.996687C122.759 -0.465595 143.936 24.8348 149.789 41.7521C160.419 59.3875 164.458 79.9956 160.497 100.203C156.593 120.125 145.871 138.586 128.69 149.4C112.14 159.817 91.4386 160.749 72.5916 155.534C55.3542 150.765 43.7491 136.865 32.6618 122.831Z",
    fill: "#ff014f",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElips1C7F3C9Ef);
export default __webpack_public_path__ + "static/media/elips-1.c7f3c9ef.2e8450c961c2d67aed39dff76f8730de.svg";
export { ForwardRef as ReactComponent };